var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOrangeM = function SvgOrangeM(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 78,
    height: 84,
    viewBox: "0 0 78 84",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7B422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8400"
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M88.787 9.258c-21.075 11.76-16.1 24.173-61.376 43.695-44.32 19.11-32.148 60.461 16.796 72.488 34.321 8.433 57.575 48.134 98.18 30.666C198.552 131.946 159.073 91.105 165 47.134 168.784 19.071 147.575.502 120.895.5c-10.264 0-21.334 2.746-32.108 8.758"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "46.834%",
    x2: "74.061%",
    y1: "50%",
    y2: "25.056%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7B422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F7B422"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF8400"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.9,
    transform: "translate(-95 -77)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M117.255.611C104.115 12.371 96 28.553 96 46.416c0 35.945 32.862 65.084 73.399 65.084 1.207 0 2.408-.026 3.601-.077-1.795-19.25-10.817-41.19-7.747-63.964C169.06 19.2 147.713.502 120.86.5c-1.192 0-2.394.036-3.605.111",
    mask: "url(#d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M3.24 74.11c-10.646 19.733 5.45 43.667 40.804 52.315 20.093 4.915 36.386 20.54 54.608 29.075A57.31 57.31 0 0 0 103 133.606C103 98.2 70.47 69.5 30.344 69.5c-9.582 0-18.728 1.636-27.104 4.61",
    mask: "url(#d)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOrangeM);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/orange-m.e79e77071327d12df7939d3ea9f2d4a4.svg";